export default [
    {
        text: 'автоматические ворота',
        modelName: 'hasAutomaticGates'
    }, {
        text: 'автомойка',
        modelName: 'hasCarWash'
    }, {
        text: 'автосервис',
        modelName: 'hasCarService'
    }, {
        text: 'aквапарк',
        modelName: 'hasAquapark'
    }, {
        text: 'аптека',
        modelName: 'hasPharmacy'
    }, {
        text: 'ателье одежды',
        modelName: 'hasClothesStudio'
    }, {
        text: 'банкомат',
        modelName: 'hasAtm'
    }, {
        text: 'бассейн',
        modelName: 'hasPool'
    }, {
        text: 'беби-ситинг',
        modelName: 'hasBabySitting'
    }, {
        text: 'боулинг',
        modelName: 'hasBowling'
    }, {
        text: 'буфет',
        modelName: 'hasBuffet'
    }, {
        text: 'видеонаблюдение',
        modelName: 'hasVideoSurveillance'
    }, {
        text: 'выставочно-складской комплекс',
        modelName: 'hasExhibitionAndWarehouseComplex'
    }, {
        text: 'въезд по пропускам',
        modelName: 'hasEntryByPass'
    }, {
        text: 'гостиница',
        modelName: 'hasHotel'
    }, {
        text: 'игровая комната',
        modelName: 'hasGameRoom'
    }, {
        text: 'игровые автоматы',
        modelName: 'hasSlotMachines'
    }, {
        text: 'каток',
        modelName: 'hasRink'
    }, {
        text: 'кафе',
        modelName: 'hasCafe'
    }, {
        text: 'кинотеатр',
        modelName: 'hasCinema'
    }, {
        text: 'конференц-зал',
        modelName: 'hasConferenceRoom'
    }, {
        text: 'круглосуточная охрана',
        modelName: 'hasHourSecurity'
    }, {
        text: 'медицинский центр',
        modelName: 'hasMedicalCenter'
    }, {
        text: 'минимаркет',
        modelName: 'hasMinimarket'
    }, {
        text: 'нотариальная контора',
        modelName: 'hasNotaryOffice'
    }, {
        text: 'отделение банка',
        modelName: 'hasBankDepartment'
    }, {
        text: 'офисные помещения',
        modelName: 'hasOfficeSpace'
    }, {
        text: 'парк',
        modelName: 'hasPark'
    }, {
        text: 'подвал/погреб',
        modelName: 'hasBasement'
    }, {
        text: 'ресторан',
        modelName: 'hasRestaurant'
    }, {
        text: 'салон красоты',
        modelName: 'hasBeautyShop'
    }, {
        text: 'складские помещения',
        modelName: 'hasWarehouse'
    }, {
        text: 'смотровая яма',
        modelName: 'hasInspectionPit',
    }, {
        text: 'столовая',
        modelName: 'hasCanteen'
    }, {
        text: 'супермаркет',
        modelName: 'hasSupermarket'
    }, {
        text: 'торговая зона',
        modelName: 'hasShoppingArea'
    }, {
        text: 'фитнес-центр',
        modelName: 'hasFitnessCentre'
    }, {
        text: 'фотосалон',
        modelName: 'hasStudio'
    }, {
        text: 'фуд-корт',
        modelName: 'hasFoodCourt'
    }, {
        text: 'центральная рецепция',
        modelName: 'hasCentralReception'
    }, {
        text: 'шиномонтаж',
        modelName: 'hasTire'
    }
];
